module.exports = __webpack_public_path__ + "img/branton-poster-image.70f1ae21.jpg";